export default __webpack_public_path__ + "static/media/rating_active_2.244d6819.png";